import styles from './styes.module.scss'
import { Typography } from 'shared/ui/Typography'
import { Button } from 'shared/ui/Button/Button'
import { AngleDown, Plus } from 'shared/assets/icons'
import { useSearchParams } from 'react-router-dom'

export const InboxCard = () => {
  const [params, setSearchParams] = useSearchParams()

  const onNew = () => {
    params.set('new', '')
    setSearchParams(params)
  }
  return (
    <div className={styles.wrap}>
      <div className={styles.left}>
        <Typography variant={'p1-semiBold'}>Inbox</Typography>
        <Typography variant={'s2-regular'} color={'--primary-color-gray-1'}>
          (555) 757-0909
        </Typography>
      </div>
      <div className={styles.right}>
        <Button variant={'tertiary-small'} LeftIcon={AngleDown} />
        <Button
          variant={'secondary-small-text'}
          LeftIcon={Plus}
          onClick={onNew}
        />
      </div>
    </div>
  )
}
